(function() {
angular.module('GorillaBoy.services')
.factory('RegionService', ['$q', '$timeout', '$window',
    function($q, $timeout, $window) {

    // TODO amaanp: remove log statements after behavior is confirmed working
    var regionService = {};

    regionService.region = function() {
        var completed = $q.defer();
        $timeout(function () {
            completed.resolve($window.AWSZocaloRegion);
        });
        return completed.promise;
    };

    regionService.getRealRegion = function() {
        return $window.RealAWSZocaloRegion;
    };

    regionService.getRegion = function () {
        return $window.AWSZocaloRegion;
    };

    return regionService;

}]);
}());
